<!-- CONFIRMATION / THANK-YOU PAGE -->
<div class="confirmation-page" *ngIf="this.parent.loading != true">

  <!-- Top: Check + Thank you -->
  <section class="hero">
    <div class="hero__icon">
      <i class="material-icons" aria-hidden="true">check</i>
    </div>

    <h1 class="hero__title" *ngIf="this.OfferRequest?.OfferRequestStatus?.ID < 10">
      {{ 'ThankYouForYouOrderRequest' | translate }}
    </h1>
    <h1 class="hero__title" *ngIf="this.OfferRequest?.OfferRequestStatus?.ID == 10">
      {{ 'ThankYouForYouPurchaseOrderRequest' | translate }}
    </h1>

    <div class="hero__meta">
      <div class="meta__item">
        <span class="meta__label">{{ 'RequestNumber' | translate }}:</span>
        <span class="meta__value">#{{ OfferRequest?.ReferenceNumber }}</span>
      </div>

      <div class="meta__item" *ngIf="this.OfferRequest?.DebatorPO?.length > 0">
        <span class="meta__label">{{ 'DebatorPO' | translate }}:</span>
        <span class="meta__value">#{{ OfferRequest?.DebatorPO }}</span>
      </div>
    </div>

    <p class="hero__message">{{ ConfirmationMessage }}</p>
  </section>

  <!-- Order total -->
  <section class="card" *ngIf="this.OfferRequest?.Cart?.Currency?.ID > 0">
    <div class="total-line">
      <span class="total-line__label">Total:</span>
      <span class="total-line__amount">
        {{ this.OfferRequest.Cart?.Total?.UITotalQtyPriceNOVAT?.Integer
        }}<span class="total-line__decimals">{{ this.OfferRequest.Cart?.Total?.UITotalQtyPriceNOVAT?.Decimals }}</span>
        <span class="total-line__currency">{{ this.OfferRequest.Cart?.Currency?.Name }}</span>
      </span>
    </div>
  </section>

  <!-- Items list -->
  <section class="card">
    <h2 class="card__title">{{ 'Items' | translate }}</h2>

    <div class="items" (keydown)="this.parent.handleKeyDown($event)">
      <div class="items__header">
        <div class="col col--n">#</div>
        <div class="col col--brand">{{ 'Brand' | translate }}</div>
        <div class="col col--name">
          {{ 'ProductNamePartNumber' | translate }}
        </div>
        <div class="col col--qty">{{ 'Quantity' | translate }}</div>
        <div class="col col--price">{{ 'Price' | translate }}</div>
        <div class="col col--total">{{ 'Total' | translate }}</div>
        <div class="col col--eta">{{ 'ETA' | translate }}</div>
      </div>

      <div
        class="items__row"
        *ngFor="let item of this.OfferRequest?.Cart?.Items; let i = index"
        [ngClass]="{'row--selected': item?.IsSelected === true, 'row--awaiting': item?.CartItemStatus?.ID == -1, 'row--notfound': item?.CartItemStatus?.ID == -2 && item?.WasSearchedFor == true, 'row--valid': item?.CartItemStatus?.ID == 1, 'row--invalid': item?.CartItemStatus?.ID == 0}"
      >
        <!-- # -->
        <div class="col col--n">{{ i + 1 }}</div>

        <!-- Brand -->
        <div class="col col--brand">
          <span *ngIf="item?.CartItemStatus?.ID >= 0">{{ item?.Product?.Brand?.Name }}</span>
          <span *ngIf="item?.CartItemStatus?.ID == -1">{{ 'ItemNeedsSelection' | translate }}</span>
          <span *ngIf="item?.CartItemStatus?.ID == -2 && item?.UIProductValue?.length > 0 && item?.WasSearchedFor == true && item.UserSelectedBrand == null">
            {{ 'SelectBrand' | translate }}
          </span>
          <span *ngIf="item?.CartItemStatus?.ID == -2 && item?.UIProductValue?.length > 0 && item?.WasSearchedFor == true && item.UserSelectedBrand != null">
            {{ item?.UserSelectedBrand?.Name }}
          </span>
        </div>

        <!-- Product name / PN -->
        <div class="col col--name">
          <span class="name__text" *ngIf="item.LoadingCell != true">{{ item?.UIProductValue }}</span>
          <span class="name__loading" *ngIf="item.LoadingCell == true">
            <mat-spinner diameter="20" class="cell-spinner"></mat-spinner>
          </span>

          <i class="material-icons name__status" *ngIf="item?.CartItemStatus?.ID == 1" aria-hidden="true">check</i>
          <i class="material-icons name__status" *ngIf="item?.CartItemStatus?.ID == -1" aria-hidden="true">keyboard_arrow_down</i>
        </div>

        <!-- Qty -->
        <div class="col col--qty">
          <div class="moq" *ngIf="item?.SelectedOffer?.ChangedQunatityFromMOQ == true"
               matTooltip="{{'MOQDesc' | translate}} {{item.SelectedOffer?.MOQ}}" matTooltipClass="neutral-tool-tip"></div>
          <span *ngIf="item?.Quantity > 0">{{ item?.Quantity }}</span>
        </div>

        <!-- Unit Price -->
        <div class="col col--price">
          <span *ngIf="item?.Price">{{ item?.Price?.UIUnitPrice }} {{ this.OfferRequest.Cart?.Currency?.Name }}</span>
        </div>

        <!-- Total -->
        <div class="col col--total">
          <span *ngIf="item?.Price">{{ item?.Price?.UIQtyPrice }} {{ this.OfferRequest.Cart?.Currency?.Name }}</span>
        </div>

        <!-- ETA -->
        <div class="col col--eta">
          <span class="eta-dot" *ngIf="item?.RequestDeliveryStatus?.ID == -1" style="background:#f60;" matTooltip="{{item?.RequestDeliveryStatus?.Name}}" matTooltipClass="neutral-tool-tip"></span>
          <span class="eta-dot" *ngIf="item?.RequestDeliveryStatus?.ID == 0" style="background:#32aa3a;" matTooltip="{{item?.RequestDeliveryStatus?.Name}}" matTooltipClass="neutral-tool-tip"></span>
          <span class="eta-dot" *ngIf="item?.RequestDeliveryStatus?.ID == 1" matTooltip="{{item?.RequestDeliveryStatus?.Name}}" matTooltipClass="neutral-tool-tip"></span>

          <span *ngIf="item?.SelectedOffer?.LeadTime?.Units > 0;">
            {{ item?.SelectedOffer?.LeadTime?.Units }} {{ item?.SelectedOffer?.LeadTime?.Type?.Name }}
          </span>
          <span *ngIf="!(item?.SelectedOffer?.LeadTime?.Units > 0);">------</span>
        </div>
      </div>
    </div>
  </section>

<!-- Payment Details -->
<section class="info-block">
  <div class="info-block__label">{{ 'PaymentDetails' | translate }}</div>
  <div class="info-block__content">
    <div>{{ 'PaymentTerms' | translate }}: <strong>{{ OfferRequest?.Cart?.PaymentTerm?.Name }}</strong></div>
    <div>{{ 'PaymentType' | translate }}: <span *ngIf="this.OfferRequest?.Cart?.PaymentType?.Name?.length > 0;">{{ this.OfferRequest?.Cart?.PaymentType?.Name }}</span></div>
  </div>
</section>

<!-- Status -->
<section class="info-block">
  <div class="info-block__label">{{ 'Status' | translate }}</div>
  <div class="info-block__content">
    {{ OfferRequest?.OfferRequestStatus?.Description }}
  </div>
</section>

<!-- What's Next -->
<section class="info-block">
  <div class="info-block__label">{{ 'WhatsNext' | translate }}</div>
  <div class="info-block__content">
    {{ OfferRequest?.OfferRequestStatus?.NextStep }}
  </div>
</section>

  <!-- Back to store -->
  <div class="footer-cta">
    <button class="cta-btn" (click)="this.parent.RedirectToURLWithUrlChange('/B2B/search');">
      <span>{{ 'BackToStore' | translate }}</span>
      <svg class="cta-btn__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
        <path fill-rule="evenodd" d="M12.293 4.293a1 1 0 011.414 0l5 5a.997.997 0 010 1.414l-5 5a1 1 0 01-1.414-1.414L15.586 11H3a1 1 0 110-2h12.586l-3.293-3.293a1 1 0 010-1.414z" clip-rule="evenodd" />
      </svg>
    </button>
  </div>
</div>